/* Where a social sign-in is meant to end up, persisted across a tab teardown.
 *
 * Social sign-in hands off to Firebase's OAuth handler, which on mobile opens
 * in a new tab — and iOS can discard the originating tab while it's
 * backgrounded, taking the in-memory destination (quoteId / redirectUrl) with
 * it. Writing it here before the handoff means a later phase can recover it on
 * return.
 *
 * localStorage rather than sessionStorage: sessionStorage is per browsing
 * context, so it dies with the tab and is not readable from the tab Firebase
 * opened. localStorage is origin-wide and survives both.
 *
 * The shape { mode, quoteId, redirectUrl } matches what the magic-link flow
 * writes (services/emailLink.js), but the key is deliberately separate for now
 * so writing one flow's context cannot clobber the other's — email-link.vue
 * already consumes the magic-link key. The two get unified in the phase that
 * adds a single reader for both.
 *
 * NOTE: nothing reads this yet. It is written and cleared only.
 */

export const SOCIAL_AUTH_CTX_KEY = 'ps_social_auth_ctx'

// { mode, quoteId, redirectUrl } — plus a write timestamp, so a consumer can
// ignore a context left behind days ago.
export function setAuthContext(ctx = {}) {
  try {
    window.localStorage.setItem(
      SOCIAL_AUTH_CTX_KEY,
      JSON.stringify({ ...ctx, ts: Date.now() })
    )
  } catch (e) {
    // Private mode or quota. The in-memory path is unaffected.
  }
}

export function getAuthContext() {
  try {
    return JSON.parse(window.localStorage.getItem(SOCIAL_AUTH_CTX_KEY) || '{}')
  } catch (e) {
    return {}
  }
}

export function clearAuthContext() {
  try {
    window.localStorage.removeItem(SOCIAL_AUTH_CTX_KEY)
  } catch (e) {
    // Nothing to do — a stale context is inert until something reads it.
  }
}
